import axios from 'axios';
import { APP_CONFIG } from '@/constants/app';

export interface CertificateResult {
  _id: string;
  userName: string;
  assessmentName: string;
  difficulty: string;
  score: number;
  dateOfAssessment: string;
}

export interface CertificateResponse {
  success: boolean;
  message: string;
  data: CertificateResult;
}

class CertificateService {
  async getPublicCertificate(attemptId: string): Promise<CertificateResponse> {
    try {
      const response = await axios.get<CertificateResponse>(
        `${APP_CONFIG.API_BASE_URL}/assessment/public/result/${attemptId}`,
        {
          headers: {
            'accept': 'application/json'
          },
          timeout: 30000
        }
      );
      
      return response.data;
    } catch (error: any) {
      if (error.response?.data) {
        throw error.response.data;
      }
      throw {
        success: false,
        message: 'Failed to fetch certificate data',
        error: error.message || 'Unknown error'
      };
    }
  }
}

export const certificateService = new CertificateService();